import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">热门话题标签</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">探索当前最受关注的内容频道与资源入口</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.label}
              href="#media"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              {topic.label}
              <span className={`text-xs ${topic.hot ? 'text-background-50/80' : 'text-foreground-400'}`}>
                {topic.count.toLocaleString()}
              </span>
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}